import { render, staticRenderFns } from "./TvaCard.vue?vue&type=template&id=34f65219&scoped=true&"
import script from "./TvaCard.vue?vue&type=script&lang=js&"
export * from "./TvaCard.vue?vue&type=script&lang=js&"
import style0 from "./TvaCard.vue?vue&type=style&index=0&id=34f65219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f65219",
  null
  
)

export default component.exports